export default function BrandMark({ className = 'h-8 w-8' }) {
    return (
        <span className={`inline-flex items-center justify-center ${className}`}>
            <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full">
                <defs>
                    <linearGradient id="dt-mark-grad" x1="0" y1="0" x2="40" y2="40" gradientUnits="userSpaceOnUse">
                        <stop offset="0" stopColor="#00E5FF" />
                        <stop offset="0.6" stopColor="#48FFAF" />
                        <stop offset="1" stopColor="#00E5FF" />
                    </linearGradient>
                </defs>
                <circle cx="20" cy="20" r="18" stroke="url(#dt-mark-grad)" strokeWidth="1.5" />
                <circle cx="20" cy="20" r="11" stroke="rgba(255,255,255,0.35)" strokeWidth="1" />
                <path d="M14 20 L20 14 L26 20 L20 26 Z" fill="url(#dt-mark-grad)" opacity="0.95" />
                <circle cx="20" cy="20" r="2.4" fill="#0a0e16" />
            </svg>
        </span>
    );
}
